module.exports = __webpack_public_path__ + "static/media/alecec.45efc3c7.webp";